import { Button, Dialog, Grid, Typography } from "@material-ui/core";
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import SaveIcon from "@material-ui/icons/Save";
import CancelIcon from "@material-ui/icons/Cancel";
import { useDispatch } from "react-redux";
import { NuevaObservacionEmpresa } from "../../actions/comunicacionConEmpresas/comunicacionConEmpresas";
import { useForm } from "../../hooks/useForm";

export const NuevaObservacionModal = (props) => {
    const dispatch = useDispatch();
    const formInicial = {
        observacion: ''
    }
    const [formValues, handleInputChange] = useForm(formInicial);

    const handleSave = () => {
        const data = {
            Cuit: props.cuit,
            Observaciones: formValues.observacion
        }
        dispatch(NuevaObservacionEmpresa(data))
        dispatch(props.onClose);
    }
    return (
        <Dialog
            fullWidth
            maxWidth={"sm"}
            open={props.open}>
            <ValidatorForm onSubmit={handleSave}>
                <Grid container style={{ padding: 25 }}>
                    <Grid item xs={12} md={12} style={{ textAlign: 'center' }}>
                        <Typography variant="h6">Nueva Observacion</Typography>
                    </Grid>
                    <Grid item xs={12} md={12} style={{ marginBottom: '1rem' }} >
                        <TextValidator
                            value={formValues.observacion}
                            name="observacion"
                            label="Observacion"
                            onChange={handleInputChange}
                            autoComplete="off"
                            fullWidth
                        />
                    </Grid>
                    <Grid container style={{ padding: 25 }} >
                        <Grid item xs={12}>
                            <Grid
                                container
                                spacing={1}
                                direction="row"
                                justify="flex-end"
                                alignItems="center"
                            >
                                <Button
                                    variant="contained"
                                    color="secondary"
                                    size="small"
                                    startIcon={<CancelIcon />}
                                    onClick={props.onClose}
                                >
                                    CANCELAR
                                </Button>
                                {
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        size="small"
                                        startIcon={<SaveIcon />}
                                        type='submit'
                                        style={{ marginLeft: "0.5rem" }}
                                    >
                                        ENVIAR
                                    </Button>
                                }
                            </Grid>
                        </Grid>
                    </Grid>

                </Grid>
            </ValidatorForm>
        </Dialog>
    );
};